<template>
    <div class="collectedBox">
        <ul>
            <li v-for="(item, index) in bookList" :key="index" class="bookList_book_style" @click="goBook(item.book)" :title="item.name">
                <dl>
                    <dt>
                        <img :src="item.cover" alt="">
                        <div>
                            <div></div>
                            <p>{{ item.plays }}</p>
                        </div>
                    </dt>
                    <dd>
                        <p>{{ item.name }}</p>
                        <p>{{ item.author }}</p>
                    </dd>
                </dl>
            </li>
        </ul>
        <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
    </div>
</template>
<script>
import pager from '../pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            bookList: [],
            totalPage: 1,
            pageNum: 1,
            isShowPager: false,
        }
    },
    mounted() {
        let that = this;
        that.collectBooks();
    },
    methods: {
        collectBooks() {
            let that = this;
            let data = {
                page: that.pageNum,
                size: 15
            }
            that.allApi.collectList(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    if( resource.data.data.list.length > 0 ) {
                        that.bookList = resource.data.data.list;
                        if( that.pageNum == 1 ) {
                            that.totalPage = resource.data.data.pages;
                            if( that.totalPage == 1 ) {
                                that.isShowPager = false;
                            }else{
                                that.isShowPager = true;
                            }
                        }
                    }else{
                        that.$router.push({
                            path: "noBook",
                            query: {
                                type: "collect"
                            }
                        });
                    }                    
                }else if( resource.data.code == 401 ) {
                    that.$router.push({
                        path: "/"
                    });
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.collectBooks();
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum(bookId);
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
        },
        addClickNum(bookId) {
            let that = this;
            let data = {
                book: bookId
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .collectedBox{
        overflow: hidden;
        padding-bottom: 30px;
        >ul{
            display: flex;
            flex-wrap: wrap;
            padding: 0 34px;
            >li{
                width: 145px;
                margin-right: 24px;
                margin-bottom: 28px;
                &:nth-child(5n) {
                    margin-right: 0;
                }
            }
        }
    }
</style>
